import { Toaster } from 'react-hot-toast';
import { QueryClient, QueryClientProvider } from 'react-query';
import {
  BrowserRouter,
  Outlet,
  Route,
  Routes,
  useLocation,
} from 'react-router-dom';

import { Footer } from '@/components/Footer';
import { Header } from '@/components/Header';
import { ChangeDate } from '@/pages/ChangeDate';
import { Home } from '@/pages/Home';
import { Label } from '@/pages/Label';
import { NotFound } from '@/pages/NotFound';
import { Sink } from '@/pages/Sink';
import { Track } from '@/pages/Track';

const PageShell = () => (
  <div className='flex min-h-0 flex-1 flex-col'>
    <Outlet />
  </div>
);

const App = () => {
  const location = useLocation();
  const hideLayoutChrome = location.pathname.startsWith('/track');

  return (
    <div className='flex min-h-[100dvh] flex-1 flex-col font-content selection:bg-black selection:text-white'>
      {!hideLayoutChrome && <Header />}
      <main className='flex min-h-0 flex-1 flex-col'>
        <Routes>
          <Route element={<PageShell />}>
            <Route element={<Home />} path='' />
            {import.meta.env.DEV && <Route element={<Sink />} path='sink' />}
            <Route path='track'>
              <Route element={<Track />} path=':trackingNumber' />
              <Route
                element={<ChangeDate />}
                path=':trackingNumber/change-date'
              />
              <Route element={<Label />} path=':trackingNumber/label' />
            </Route>
            <Route element={<NotFound />} path='*' />
          </Route>
        </Routes>
      </main>
      {!hideLayoutChrome && <Footer className='mt-auto' />}
      <Toaster position='bottom-center' />
    </div>
  );
};

const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      onError: (error) => {
        console.error('Mutation error:', error);
      },
    },
    queries: {
      onError: (error) => {
        console.error('Query error:', error);
      },
    },
  },
});

const Providers = () => {
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </BrowserRouter>
  );
};

export default Providers;
